module.exports = __webpack_public_path__ + "static/media/banner-desktop.791539dc.webp";